import script from "./ClassSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./ClassSummaryView.vue?vue&type=style&index=0&id=698d10c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-698d10c4"]])

export default __exports__